// components/IntroducingVoxHeader.js
import React from "react";
import styled from "styled-components";

const Wrapper = styled.header`
  background: #000;
  padding: 3rem 1rem 4rem;
  text-align: center;
`;

const Line1 = styled.h1`
  color: #fff;
  font-family: "Anybody", sans-serif;
  font-weight: 900;
  font-size: clamp(2.5rem, 8vw, 6rem);
  margin: 0;
`;
const Line2 = styled.p`
  color: #fff;
  font-family: "Anybody", sans-serif;
  font-weight: 700;
  font-size: clamp(1.4rem, 4vw, 2.5rem);
  margin: 1rem 0 0;
`;
const Line3 = styled.p`
  color: #fff;
  font-family: "Anybody", sans-serif;
  font-weight: 700;
  font-size: clamp(1.2rem, 3.5vw, 2rem);
  margin: 0.5rem 0 0;
`;

export function IntroducingVoxHeader() {
  return (
    <Wrapper>
      <Line1>INTRODUCING, RIFF.AI</Line1>
      <Line2>
        MEET RIFF.AI, RIFF MAGAZINE’S UNIQUE AI SYSTEM HERE TO CURATE A
        SPECIALISED PLAYLIST JUST FOR YOU
      </Line2>
      <Line3>
        FOLLOW THE STEPS BELOW TO DISCOVER WHAT YOUR PERSONAL SOUNDSCAPE IS…
      </Line3>
    </Wrapper>
  );
}
